import axios from 'axios'

// 创建 axios 实例
const http = axios.create({
//   baseURL: 'http://2400855f.r5.cpolar.cn',
  timeout: 10000 // 请求超时时间
})

export default http